import $ from 'jquery';

function init() {
  cartOpen()
  menuOpen()
}

export function cartOpen() {
  $('.nav-cartButton').click(function(e) {
    e.preventDefault()
    cart.open = true
  })
}

function menuOpen() {
  $('.nav-hamburger').click(function(e) {
    e.preventDefault()
    if ($(this).hasClass('nav-hamburger--open')) {
      $(this).removeClass('nav-hamburger--open')
      $('body').removeClass('scrollLock')
      $('.header').removeClass('header--navOpen')
    } else {
      $(this).addClass('nav-hamburger--open')
      $('body').addClass('scrollLock')
      $('.header').addClass('header--navOpen')
    }
  })
}

$(document).ready(function () {
  init()
})
